import { useNotification, useTimeZone } from '../../../../../hooks'
import { updateMockCalendarTaskDeadline } from '../../../Calendar.mock'
import {
  CalendarTaskMoveModal,
  getCalendarTaskMoveInitialValues,
} from '../../../CalendarTaskMoveModal'

export function useCalendarViewTaskMove({
  getActionToken,
  setModal,
  onClose,
  onReload,
}) {
  const timezone = useTimeZone()

  const { handleAddErrorNotification, handleAddSuccessNotification } =
    useNotification()

  async function handleSubmitTaskMove({ item, payload, setSubmitting }) {
    const actionToken = getActionToken()

    // TODO: write the deadline with the task update once the calendar reads
    // real tasks.
    return updateMockCalendarTaskDeadline({
      deadline: payload.deadline,
      id: item.id,
      sourceDate: item.date,
      timezone,
    })
      .then(() => {
        if (getActionToken() === actionToken) {
          onClose()
        }

        onReload()

        handleAddSuccessNotification('Notification.CommonTitleSavedKey')
      })
      .catch(() => {
        setSubmitting(false)

        handleAddErrorNotification('Error.CommonApiRequestFailKey')
      })
  }

  function handleOpenTaskMove({ date, item }) {
    setModal(
      <CalendarTaskMoveModal
        initialValues={getCalendarTaskMoveInitialValues({
          date,
          item,
          timezone,
        })}
        item={item}
        onClose={onClose}
        onSubmit={handleSubmitTaskMove}
      />
    )
  }

  return { handleOpenTaskMove }
}
